import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './../locales/en/index.json';
import de from './../locales/de/index.json';
import fr from './../locales/fr/index.json';
import nl from './../locales/nl/index.json';
import es from './../locales/es/index.json';
import it from './../locales/it/index.json';
import tr from './../locales/tr/index.json';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      de: { translation: de },
      fr: { translation: fr },
      nl: { translation: nl },
      es: { translation: es },
      it: { translation: it },
      tr: { translation: tr },
    },
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
  });

export default i18n;
